export default "__VITE_ASSET__Dir$v5zu__"